import type { GenericAbortSignal } from "axios";
import { createInfiniteQuery } from "react-query-kit";

import type {
  IInfinitePatternsParams,
  IInfinitePatternResponse,
} from "./types";

import { axiosClient } from "@/api";
import type { IWithInfinite } from "@api/types.ts";
import { getApi } from "@api/apiPath";

const { key, getPath } = getApi("infinite.getAllPatterns");

type IResponse = IWithInfinite<IInfinitePatternResponse>;
type IVariables = IInfinitePatternsParams;

const getAllInfinitePatterns = async (
  props: IVariables & { cursor: number },
  signal?: GenericAbortSignal,
): Promise<IResponse> => {
  const { data } = await axiosClient.get(getPath(props), {
    params: props,
    signal,
  });

  return data.data;
};

export const useGetAllInfinitePatterns = createInfiniteQuery<
  IResponse,
  IVariables
>({
  primaryKey: `infinite_${key}`,
  queryFn: ({ queryKey: [_primaryKey, variables], pageParam, signal }) =>
    getAllInfinitePatterns({ ...variables, cursor: pageParam }, signal),
  getNextPageParam: (lastPage) => lastPage.nextCursor,
  //   initialPageParam: 1
});
